'use client';

import React from 'react';
import { useGlobalClientContext } from '../../common/GlobalClientContext';
import storageImg from '../../../../public/images/storage.png';

export default function Product() {
  const {
    i18nHelper: { t },
  } = useGlobalClientContext();

  return (
    <>
      <div className="flex flex-[1] flex-col items-center gap-3xl mb-9xl">
        <div className="text-5xl leading-18xl text-gray-900 font-semibold whitespace-nowrap">
          {t('public.site.product.storage.feature1', {})}
        </div>
        <div className="text-xl font-regular leading-3xl text-gray-600 text-center w-[800px]">
          {t('public.site.product.storage.feature1.desc', {})}
        </div>
      </div>
      <img src={storageImg.src} alt="storage" />
      <div className="flex flex-row gap-10xl mt-9xl">
        <div className="flex flex-row gap-9xl">
          <div className="flex flex-1 flex-col gap-2xs w-[324px]">
            <div className="text-xl font-semibold leanding-lg text-primary">
              {t('public.site.product.storage.feature2', {})}
            </div>
            <div className="text-md font-regular leading-lg text-secondary">
              {t('public.site.product.storage.feature2.desc', {})}
            </div>
          </div>
          <div className="flex flex-1 flex-col gap-2xs w-[324px]">
            <div className="text-xl font-semibold leanding-lg text-primary">
              {t('public.site.product.storage.feature3', {})}
            </div>
            <div className="text-md font-regular leading-lg text-secondary">
              {t('public.site.product.storage.feature3.desc', {})}
            </div>
          </div>
          <div className="flex flex-1 flex-col gap-2xs w-[324px]">
            <div className="text-xl font-semibold leanding-lg text-primary">
              {t('public.site.product.storage.feature4', {})}
            </div>
            <div className="text-md font-regular leading-lg text-secondary">
              {t('public.site.product.storage.feature4.desc', {})}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
